<p-confirmDialog key="staffportal" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div>
	<caass-personselector [AudienceID]="2"></caass-personselector>
</div>

<!--Instructions-->
<div class="InfoDiv">
	<h4 style="text-align: center">Instructions</h4>
	<div>
		<ul>
			<li>Download CAASS Staff Portal from the App Store</li>
			<li>Open Staff Portal App, it will ask you to register</li>
			<li>Scan the QR code below to register</li>
			<li>Note: Please scan the QR code with the Staff App, <span style="color: orangered">NOT</span> the normal Camera App.</li>
		</ul>

		<p style="text-align: center">You can also enter an email address and send the QR code to the staff member</p>
	</div>
</div>

<!--QR-->
<div class="QRDiv" *ngIf="ShowQRCode == true">
	<div *ngIf="QRLoading == false && QRCode != ''">
		<img [src]="QRCode" />
	</div>

	<div *ngIf="QRLoading == true" class="LoadingDiv">
		<p-progressSpinner></p-progressSpinner>
	</div>
</div>

<!--Options-->
<div style="margin-top: 15px">
	<div class="EmailDiv">
		<label>Staff Email:</label>
		<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Email" />

		<div class="LockOptionGrid">
			<label for="LockEmail">Lock Email:</label>
			<input [disabled]="IsLoading() == true || SyncWithCAASS == true" id="LockEmail" type="checkbox" class="CHK" [(ngModel)]="LockEmail" />

			<label *ngIf="HasUserAccount == true" for="SyncWithCAASS">Sync With CAASS Login:</label>
			<input
				*ngIf="HasUserAccount == true"
				[disabled]="IsLoading() == true"
				id="SyncWithCAASS"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SyncWithCAASS"
				(ngModelChange)="onSyncWithCaassChange($event)"
			/>
		</div>
	</div>

	<div class="Buttons">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onGenerate()">Generate QR Code</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEmail()">Email</button>
	</div>
</div>

<div class="TopMargin">
	<div name="ErrorMessage" *ngIf="ErrorMessage" class="alert alert-danger">{{ ErrorMessage }}</div>
</div>

<!--Registered Accounts-->
<div class="InfoDiv" style="margin-top: 45px">
	<h4 style="text-align: center; margin: 0px">Registered Account(s)</h4>
</div>

<div style="padding: 0px 20px 20px 20px">
	<button class="btn btn-primary" (click)="onRefresh()">Refresh</button>
</div>

<!--Table-->
<div>
	<p-table
		#mydt
		[value]="lstRegUser"
		[loading]="LoadingRegUser"
		[paginator]="true"
		[(rows)]="reguserpagerows"
		[(first)]="reguserpagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedRegUser"
		dataKey="RegUserID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UserID_Email-->
				<th>
					<p-columnFilter type="text" field="UserID_Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LanguageDesc-->
				<th>
					<p-columnFilter field="LanguageDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterLanguageDesc
								[ngModel]="value"
								[options]="lstLanguageDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--RegPersonActiveDesc-->
				<th>
					<p-columnFilter field="RegPersonActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterRegPersonActiveDesc
								[ngModel]="value"
								[options]="lstRegPersonActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="UserID_Email">Email<p-sortIcon field="UserID_Email"></p-sortIcon></th>
				<th pSortableColumn="LanguageDesc">Language<p-sortIcon field="LanguageDesc"></p-sortIcon></th>
				<th pSortableColumn="RegPersonActiveDesc">Assigned to Student<p-sortIcon field="RegPersonActiveDesc"></p-sortIcon></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-RegUser>
			<tr [pSelectableRow]="RegUser">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.FirstName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.LastName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.UserID_Email }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.LanguageDesc }}
				</td>
				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="RegUser.RegPersonActive == true ? 'Black' : 'Red'"
				>
					{{ RegUser.RegPersonActive == true ? "Assigned" : "Removed" }}
				</td>
				<td>
					<button *ngIf="RegUser.RegPersonActive == true" class="btn btn-danger" (click)="onUpdateRegPerson(RegUser, 0)">Remove User</button>
					<button *ngIf="RegUser.RegPersonActive == false" class="btn btn-success" (click)="onUpdateRegPerson(RegUser, 1)">Re-Activate User</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
